'use client'

const REDIRECT_ATTEMPT_KEY = 'auth-redirect-attempted'
const REDIRECT_ATTEMPT_TTL_MS = 10_000

export function markRedirectAttempted(): void {
  try {
    sessionStorage.setItem(
      REDIRECT_ATTEMPT_KEY,
      JSON.stringify({ attemptedAt: Date.now() }),
    )
  } catch {}
}

export function consumeRedirectAttempted(): boolean {
  try {
    const raw = sessionStorage.getItem(REDIRECT_ATTEMPT_KEY)
    sessionStorage.removeItem(REDIRECT_ATTEMPT_KEY)
    if (!raw) return false
    if (raw === '1') return true

    const parsed = JSON.parse(raw) as { attemptedAt?: unknown }
    return (
      typeof parsed.attemptedAt === 'number' &&
      Date.now() - parsed.attemptedAt <= REDIRECT_ATTEMPT_TTL_MS
    )
  } catch {
    return false
  }
}

export function clearRedirectAttempted(): void {
  try {
    sessionStorage.removeItem(REDIRECT_ATTEMPT_KEY)
  } catch {}
}
